import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/lib/constants";

export default function Seo({
  title,
  description,
  path = "/",
  image = "/images/og-share.jpg",
  jsonLd = [],
  noindex = false,
}) {
  const canonical = `${COMPANY.siteUrl}${path === "/" ? "" : path}`;
  const fullImage = image.startsWith("http") ? image : `${COMPANY.siteUrl}${image}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <html lang="en-CA" />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={fullImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
